module.exports = __webpack_public_path__ + "img/gtt-logo-horizontal-negative.cec98195.svg";